import { Box, Text, useToast } from '@chakra-ui/react';
import { useContext, useEffect, useRef, useState } from 'react';

import { RadioGroup } from '../../../../components/inputs/RadioGroup';
import { BackLink } from '../../../../components/navigation/BackLink';
import { Spinner } from '../../../../components/widgets/Spinner';
import { ToggleCard } from '../../../../components/widgets/ToggleCard';
import VisualizationContext from '../../../../contexts/VisualizationContext';
import { apiSensedia } from '../../../../services/api-sensedia';
import { LayoutGestaoLeads } from './components/LayoutGestaoLeads';
import { TimerComponent } from './components/TimerComponent';
import { Toast } from './components/Toast';

export const ConfiguracoesLeads = () => {
  const [isLoadingDistribuicao, setIsLoadingDistribuicao] = useState(false);

  const [isLoadingTransbordo, setIsLoadingTransbordo] = useState(false);

  const [configData, setConfigData] = useState(null);

  const toast = useToast();

  const [showToast, setShowToast] = useState(false);
  const [messageToast, setMessageToast] = useState('');
  const [typeMessage, setTypeMessage] = useState<
    'error' | 'warn' | 'success' | ''
  >('');

  const radioInputRef = useRef('1/1');

  const timeInputRef = useRef('10');

  const { visualizationState, setVisualizationState } =
    useContext(VisualizationContext);

  const handleSaveDistribuicao = async () => {
    try {
      setIsLoadingDistribuicao(true);
      if (radioInputRef.current === 'equipe 1/1') {
        const { data } = await apiSensedia.get(
          `/oportunidades-sulamerica/painel-leads/equipes/lista-redistribuicao`,
          {
            timeout: 0
          }
        );

        if (data?.length <= 0) {
          handleShowToast(
            'open',
            'Você não possui equipes cadastradas ou ativas. Crie ou ative as suas equipes através do menu.',
            'warn'
          );
          setIsLoadingDistribuicao(false);
          return;
        }
      }

      await apiSensedia.put(
        `/oportunidades-sulamerica/painel-leads/configuracoes`,
        {
          distribuicao_automatica: true,
          tipo_distribuicao_automatica: radioInputRef.current
        }
      );

      setIsLoadingDistribuicao(false);
    } catch (error) {
      console.log(error);
      setIsLoadingDistribuicao(false);
    }

    handleShowToast('open', 'A alteração foi salva com sucesso!!!', 'success');
  };

  const handleSaveTransbordo = async () => {
    try {
      setIsLoadingTransbordo(true);

      await apiSensedia.put(
        `/oportunidades-sulamerica/painel-leads/configuracoes`,
        {
          transbordo: true,
          tempo_transbordo: +timeInputRef.current
        }
      );

      handleShowToast(
        'open',
        'A alteração foi salva com sucesso!!!',
        'success'
      );

      setIsLoadingTransbordo(false);
    } catch (error) {
      console.log(error);
      setIsLoadingTransbordo(false);
      handleShowToast(
        'open',
        'Ocorreu um erro, favor tente novamente',
        'error'
      );
    }
  };

  const onOffDistribuicao = async () => {
    try {
      await apiSensedia.put(
        `/oportunidades-sulamerica/painel-leads/configuracoes`,
        {
          distribuicao_automatica: false,
          tipo_distribuicao_automatica: '1/1'
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const onOffTransbordo = async () => {
    try {
      await apiSensedia.put(
        `/oportunidades-sulamerica/painel-leads/configuracoes`,
        {
          transbordo: false,
          tempo_transbordo:
            configData?.tempo_transbordo ?? +timeInputRef.current
        }
      );

      setIsLoadingTransbordo(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleTimeChange = (value: string) => {
    timeInputRef.current = value;
  };

  const handleRadioChange = (value: string) => {
    radioInputRef.current = value;
  };

  const handleShowToast = async (
    action: 'open' | 'close',
    message?: string,
    type?: 'error' | 'warn' | 'success'
  ) => {
    if (action === 'open') {
      await setMessageToast(message);
      await setTypeMessage(type);
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
      }, 5000);
    } else {
      setShowToast(false);
    }
  };

  const getConfigurations = async () => {
    try {
      const { data } = await apiSensedia.get(
        `/oportunidades-sulamerica/painel-leads/configuracoes`
      );

      radioInputRef.current = data?.tipo_distribuicao_automatica;
      timeInputRef.current = data?.tempo_transbordo;

      setConfigData(data);
    } catch (error: any) {
      const errorObj = error?.toJSON();
      toast({
        position: 'top',
        description: (
          <Box>
            <Text>
              {' '}
              Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
              minutos e tente fazer login novamente, se persistir, por favor
              entrar em contato.
            </Text>
            <Text>
              {errorObj?.status && (
                <>
                  <br />
                  <b>Detalhes:</b>
                  <br />
                </>
              )}
              {(errorObj?.status || error?.response?.data?.statusCode) && (
                <>{errorObj.status ?? error.response.data.statusCode}</>
              )}
              {errorObj?.status &&
                (error?.response?.data?.message || errorObj?.message) &&
                ' - '}
              {(error?.response?.data?.message || errorObj?.message) && (
                <>{error.response.data.message ?? errorObj.message}</>
              )}
            </Text>
          </Box>
        ),
        duration: 15000,
        isClosable: true,
        status: 'error'
      });
      console.log(error);
      // aquii
    }
  };

  const radioOptions = [
    {
      label: 'Para todos os vendedores 1/1',
      value: '1/1',
      checked: configData?.tipo_distribuicao_automatica === '1/1'
    },
    {
      label: 'Para todas as equipes de acordo com o produto 1/1',
      value: 'equipe 1/1',
      checked: configData?.tipo_distribuicao_automatica === 'equipe 1/1'
    }
  ];

  const toggleCards = [
    {
      title: 'Habilitar distribuição automática',
      isOn: configData?.distribuicao_automatica,
      isLoading: isLoadingDistribuicao,
      disabled: false,
      tooltip:
        'Ao chegar, o lead será distribuído automaticamente através da opção que escolher.',
      handleSave: handleSaveDistribuicao,
      onOffFunction: onOffDistribuicao,
      children: (
        <RadioGroup options={radioOptions} onChange={handleRadioChange} />
      )
    },
    {
      title: `Habilitar transbordo\npor tempo de atendimento`,
      isOn: configData?.transbordo,
      isLoading: isLoadingTransbordo,
      error: true,
      disabled: false,
      tooltip: 'Será considerado de segunda a sexta em horário comercial',
      description: `Transborde o lead para o próximo vendedor\ncaso não seja atendido em:`,
      handleSave: handleSaveTransbordo,
      onOffFunction: onOffTransbordo,
      children: null,
      saveChildren: (
        <TimerComponent
          time={configData?.tempo_transbordo}
          onChange={handleTimeChange}
        />
      )
    }
  ];

  useEffect(() => {
    setVisualizationState('gestao');
    let isMounted = true;

    if (isMounted) getConfigurations();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <LayoutGestaoLeads>
      <div className=" tw-bg-[#F4F4F4] tw-h-screen tw-px-[16px] md:tw-px-0">
        <div className="tw-flex tw-mt-[1.875rem] tw-gap-6 tw-flex-col md:tw-flex-row">
          {configData ? (
            toggleCards.map((toggleCard) => (
              <ToggleCard
                key={toggleCard.title}
                title={toggleCard.title}
                isLoading={toggleCard.isLoading}
                description={toggleCard.description}
                isOn={toggleCard.isOn}
                disabled={toggleCard.disabled}
                tooltip={toggleCard.tooltip}
                handleSave={toggleCard.handleSave}
                onOffFunction={toggleCard.onOffFunction}
                saveChildren={toggleCard.saveChildren}
              >
                {toggleCard?.children}
              </ToggleCard>
            ))
          ) : (
            <div className="tw-flex tw-justify-center tw-items-center tw-w-full tw-h-[10rem]">
              <Spinner />
            </div>
          )}
        </div>
      </div>
      {showToast && (
        <Toast
          typeMessage={typeMessage}
          message={messageToast}
          onClose={handleShowToast}
        />
      )}
    </LayoutGestaoLeads>
  );
};
